import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Switch } from "@faire/web--source/ui/routing/Switch";
import { Route } from "@faire/web-api--source/Route";
import { props as privacyRouteProps } from "@faire/web-api--source/routes/privacy";
import { props as privacyCookiesRouteProps } from "@faire/web-api--source/routes/privacy/cookies";
import React from "react";
import { LazyCookiePolicy } from "@faire/retailer/views/privacy/cookie/LazyCookiePolicy";
import { LazyPrivacyPolicy } from "@faire/retailer/views/privacy/LazyPrivacyPolicy";
export var PrivacyRouter = function() {
    return /*#__PURE__*/ _jsxs(Switch, {
        children: [
            /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, privacyRouteProps), {
                component: LazyPrivacyPolicy,
                exact: true
            })),
            /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, privacyCookiesRouteProps), {
                component: LazyCookiePolicy,
                exact: true
            }))
        ]
    });
};
